import PropTypes from "prop-types";

const CanvasIcon = ({ path, size, strokeWidth, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={path} />
  </svg>
);

CanvasIcon.propTypes = {
  path: PropTypes.string.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
};

CanvasIcon.defaultProps = {
  size: 18,
  strokeWidth: 1.8,
  className: undefined,
};

export default CanvasIcon;
